'use client';
import { init, push } from '@socialgouv/matomo-next';
import { GoogleTagManager } from '@next/third-parties/google';
import { ProviderRedux } from '../GlobalRedux/provider';
import { useTranslation } from 'react-i18next';
import '../../styles/globals.css';
import { usePathname } from 'next/navigation';
import React, { useEffect } from 'react';
import MainLayout from '@/components/Organisms/MainLayout/MainLayout';
import AuthLayout from '@/components/Organisms/AuthLayout/AuthLayout';
import { GlobalProvider } from 'src/contexts/GlobalContext';
import useOnlineStatus from 'src/hooks/useOnlineStatus';
import CustomModal from '@/components/Atoms/CustomModal';

const MATOMO_URL = process.env.NEXT_PUBLIC_MATOMO_URL || '';
const MATOMO_SITE_ID = process.env.NEXT_PUBLIC_MATOMO_SITE_ID || '';
const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || '';

export default function RootLayout({ children }: { children: React.ReactNode }) {
  const pathName = usePathname();
  const authPages = ['/', '/login', '/auth/login', '/auth/forgot-password', '/auth/registration', '/auth/verify-email', '/auth/reset-password', '/auth/two-step-verification'];
  const isAuthPage = authPages.includes(pathName);

  const isOnline = useOnlineStatus();

  const { t } = useTranslation();

  useEffect(() => {
    localStorage.removeItem('blockNavigation');
  }, []);

  useEffect(() => {
    init({
      url: MATOMO_URL,
      siteId: MATOMO_SITE_ID,
    });
    push(['trackPageView']);
  }, [pathName]);

  return (
    <html lang="en">
      <head>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600;700&display=swap"
        />
        <GoogleTagManager gtmId={GTM_ID} />
      </head>
      <body className="scroll-container">
        <ProviderRedux>
          {!isAuthPage ? (
            <GlobalProvider>
              <MainLayout>{children}</MainLayout>
            </GlobalProvider>
          ) : pathName === '/auth/verify-email' ? (
            <div>{children}</div>
          ) : pathName === '/auth/registration' ? (
            <div>{children}</div>
          ) : (
            <AuthLayout>{children}</AuthLayout>
          )}
        </ProviderRedux>

        <CustomModal
          closable={false}
          title={t('Connection Lost')}
          description={t(
            `Your internet connection has been interrupted. Please check your network settings. We’ll attempt to reconnect automatically. For assistance, contact our support team at IT-Support@de-karb.com.`
          )}
          isVisible={!isOnline}
          iconType="Info"
        />
      </body>
    </html>
  );
}
